import USER_DELETE from './userDelete.gql';

export default USER_DELETE;
export {
  USER_DELETE,
};
